module.exports = __webpack_public_path__ + "img/other.9e17b093.png";